import React from "react";
import { ArcStack } from "@src/core/ui";
import { ZoneEntity } from "@src/core/features";
import { ZoneList } from "../../ZoneList";
import { VARIANT_SAFE_LAND } from "@src/features/zones/pages/zones-page/types";


interface SectionsProps {
    safeLandZones: ZoneEntity[] | undefined;
}

export const SafeLandSections: React.FC<SectionsProps> = (props) => {
  const { safeLandZones = [] } = props;

  
  return (
    <React.Fragment >
      <ArcStack my={2} spacing={1} mt={2}>
        <ZoneList zones={safeLandZones} variant={VARIANT_SAFE_LAND} />    
      </ArcStack>
    </React.Fragment>
  );
};  